import axios from '../config/axios';
import { addFormattingInstructions } from '../utils/formattingUtils';

const API_URL = `${process.env.REACT_APP_API_URL}/api/ai`;

// One attempt. The backend retries transient Gemini failures (429 / 5xx / timeouts) itself, and a
// truncated or blocked answer fails the same way on every try, so retrying here only tripled the wait.
export const generateContent = async (prompt, context, output, sectionType = null, sectionTitle = null, sectionData = null, styleOpts = null, usdmContext = null) => {
  try {
    console.log("Prompt:", prompt);
    console.log("Section Type:", sectionType);
    console.log("Section Title:", sectionTitle);
    
    // Add formatting instructions to the prompt
    const enhancedPrompt = addFormattingInstructions(prompt);
    
    const requestBody = {
      context,
      prompt: enhancedPrompt,
      output
    };

    // Only add section parameters if they are provided
    if (sectionType) {
      requestBody.sectionType = sectionType;
    }
    if (sectionTitle) {
      requestBody.sectionTitle = sectionTitle;
    }

    if (sectionData && sectionType !== 'sap' && sectionType !== 'icf') {
      requestBody.sectionData = sectionData;
    }

    // Style fields (submissionRegion, sponsorNameFull, sponsorNameShort,
    // productName, therapeuticArea, documentType) are read flat off
    // req.body server-side by pickGenerationStyleFromBody — spread them
    // flat here rather than nesting, or they're silently ignored.
    if (styleOpts && typeof styleOpts === 'object') {
      Object.assign(requestBody, styleOpts);
    }

    if (usdmContext) {
      requestBody.usdmContext = usdmContext;
    }

    const response = await axios.post(`${API_URL}/get-result`, requestBody);

    if (!response.data || typeof response.data.result !== "string") {
      throw new Error("Invalid response format");
    }

    console.log("Raw AI Response:", response.data.result);
    return response.data.result;
  } catch (error) {
    console.error('Error fetching AI response:', error);
    throw new Error(error.response?.data?.message || error.message || "Failed to generate content");
  }
};

/**
 * Legacy function for backward compatibility
 */
export const generateContentLegacy = async (prompt, context, output) => {
  return generateContent(prompt, context, output, null, null);
};
